module.exports = __webpack_public_path__ + "img/wa.17265d51.svg";